import MotifFormController from './motif.form.controller';

export default {
    template: require('./motif.form.html'),
    controller: MotifFormController
};
